/**
 * 'Common.router.js'
 * @version 1.0.0
 * @author Fernando Torres
 * @copyright Marciano Studio S.C., 2018
 */
import PageNotFoundView from '@/views/common/page-not-found.view'

export default [
  {
    path: '*',
    component: PageNotFoundView,
    meta: {
      title: 'Página no encontrada'
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/routes/common/common.router.js